import { Alert } from "@hydrologiq/shared/chakra/Alert"
import React from "react"

interface ErrorAlertProps {
  title?: string
  message: string
  onClose?: () => void
}

/**
 * Standardized error alert component that can be used across all sections.
 * Uses the shared Alert component for consistent styling.
 */
const ErrorAlert: React.FC<ErrorAlertProps> = ({ title = "Error", message, onClose }) => {
  return (
    <Alert
      status="error"
      variant="subtle"
      title={title}
      closable={!!onClose}
      onClose={onClose}
      data-testid="error-alert"
      mb={4}
    >
      {message}
    </Alert>
  )
}

export default ErrorAlert
